import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Loader from "../../Components/Loader";

import useApi from "../../hooks/useApi";

import "./style.scss";

const FbCallback = () => {
  const navigate = useNavigate();
  const { post, put } = useApi();
  const { authType } = useParams();

  const getNameAndSurname = (fullName) => {
    const parts = fullName.trim().split(" ");
    const firstName = parts[0] || "";
    const lastName = parts.slice(1).join(" ") || "";
    return { firstName, lastName };
  };

  const tryLogin = async (data) => {
    try {
      const loginResp = await post("/User/external-login", {
        email: data.email,
        provider: data.provider,
        providerKey: data.providerKey,
        accessToken: data.accessToken,
        profileUrl: data.profileUrl,
      });

      if (loginResp.isAuthorized) {
        localStorage.setItem("ps10005000", JSON.stringify(loginResp.token));
        localStorage.setItem(
          "ps10004000",
          JSON.stringify(loginResp.refreshToken),
        );
        return { isLoggedIn: true };
      } else {
        return { isLoggedIn: false };
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const fetchFacebookUser = async () => {
      try {
        const hash = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hash.get("access_token");
        const stateRaw = hash.get("state");
        const state = stateRaw ? JSON.parse(decodeURIComponent(stateRaw)) : {};
        const redirectPathAfterLogin = state.afterLoginUrl || "/sessions";

        if (!accessToken) {
          navigate("/");
          return;
        }

        const response = await fetch(
          `https://graph.facebook.com/me?fields=id,name,email,picture&access_token=${accessToken}`,
        );
        const userInfo = await response.json();

        if (userInfo.error) {
          console.error("Error fetching user info:", userInfo.error);
          navigate("/");
          return;
        }

        const { firstName, lastName } = getNameAndSurname(userInfo.name);

        const finalData = {
          name: firstName,
          surname: lastName,
          email: userInfo.email,
          profileUrl: userInfo.picture?.data?.url,
          accessToken,
          provider: "Facebook",
          providerKey: userInfo.id,
          pricePlan: state.pricePlan,
        };

        const loginResponse = await tryLogin(finalData);

        if (loginResponse.isLoggedIn) {
          navigate(redirectPathAfterLogin, { replace: true });
        } else if (authType === "register-provider") {
          navigate("/role-selector?isSSO=true", {
            state: finalData,
          });
        } else if (authType === "register-consumer") {
          if (!!finalData.email) {
            if (finalData.email !== state?.email) {
              put("/Invitation/SetEmail", {
                id: state.invitationId,
                email: finalData.email,
              });
            }

            try {
              const registerData = await post("/User/external-register", {
                email: finalData.email,
                provider: finalData.provider,
                providerKey: finalData.providerKey,
                accessToken: finalData.accessToken,
                profileUrl: finalData.profileUrl,
                firstName: finalData.name,
                lastName: finalData.surname,
                phoneNumber: state.phoneNumber || null,
                userRole: "Consumer",
              });
              if (registerData.isAuthorized) {
                localStorage.setItem(
                  "ps10005000",
                  JSON.stringify(registerData.token),
                );
                localStorage.setItem(
                  "ps10004000",
                  JSON.stringify(registerData.refreshToken),
                );
                navigate("/sessions");
              }
            } catch (e) {
              console.error(e);
            }
          } else {
            navigate("/role-selector/consumer-registration?isSSO=true", {
              state: {
                email: finalData.email,
                name: firstName,
                surname: lastName,
                accessToken: finalData.accessToken,
                providerKey: finalData.providerKey,
                profileUrl: finalData.profileUrl,
                provider: finalData.provider,
              },
            });
          }
        } else {
          navigate("/?isSSO=true", { state: finalData });
        }
      } catch (error) {
        console.error("Facebook login failed:", error);
        navigate("/");
      }
    };

    fetchFacebookUser();
  }, [navigate, post]);

  return <Loader />;
};

export default FbCallback;
